// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"0adc27c5","787":"5a475f35"}[chunkId] + ".chunk.js";
};